export type RadarConnectionState = {
  isConnected: boolean;
  lastConnectedAt: number;
  lastDisconnectedAt: number;
  totalMessages: number;
  errors: number;
};

export type ConnectionStateMap = Record<string, RadarConnectionState>;

type WebSocketEventType = "connected" | "disconnected" | "message" | "error";

const emptyRadarState = (): RadarConnectionState => ({
  isConnected: false,
  lastConnectedAt: 0,
  lastDisconnectedAt: 0,
  totalMessages: 0,
  errors: 0,
});

export const createConnectionStateMap = (): ConnectionStateMap => ({});

export const applyWebSocketEvent = (
  state: ConnectionStateMap,
  radarId: string,
  event: { type: WebSocketEventType }
): ConnectionStateMap => {
  const previous = state[radarId] ?? emptyRadarState();
  const radarState = { ...previous };

  switch (event.type) {
    case "connected":
      radarState.isConnected = true;
      radarState.lastConnectedAt = Date.now();
      break;
    case "disconnected":
      radarState.isConnected = false;
      radarState.lastDisconnectedAt = Date.now();
      break;
    case "message":
      radarState.totalMessages += 1;
      break;
    case "error":
      radarState.errors += 1;
      break;
  }

  return { ...state, [radarId]: radarState };
};
